import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    TableBody,
    Box,
} from '@mui/material'
import React, { useEffect } from 'react'
import { useAppDispatch } from '../../../redux/storeExports'

import { EmailTemplateSelector, fetchAllTemplates, EmailTemplateServiceLoadingSelector } from '../../../redux/emailTemplateService'
import TemplateListItem from '../../shared/atom/EmailTemplateItem'
import CenteredTabs from './Tabs'
import LottieLoader from '../../shared/atom/LottieLoader'


interface EmailListProps {
    removed?: boolean
}

const EmailList = (props: EmailListProps) => {
    const dispatch = useAppDispatch()
    const [value, setValue] = React.useState('standard');
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    useEffect(() => {
        dispatch(fetchAllTemplates())
    }, [dispatch])
    const templates = EmailTemplateSelector(value)
    const loading = EmailTemplateServiceLoadingSelector()


    return (
        <>
            <CenteredTabs value={value} handleChange={handleChange} />
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                    <LottieLoader />
                </Box>
            ) : (
                <TableContainer
                    component={Paper}
                    sx={{ minWidth: 850 }}
                    aria-label="simple table">
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Template name</TableCell>
                            <TableCell align="left">Type</TableCell>
                            <TableCell align="left">Subject</TableCell>
                            <TableCell align="left">From Email</TableCell>
                            <TableCell align="left">Schedule Time</TableCell>
                            <TableCell align="left">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {templates.map((template, index) => (
                            <TemplateListItem template={template} key={index} />
                        ))}
                    </TableBody>
                </Table>
                </TableContainer>
            )}
        </>
    )
}

const EmailTemplateListSuspense = (props: EmailListProps) => {
    return <EmailList {...props} />
}

export default EmailTemplateListSuspense

